export default "__VITE_ASSET__CipL41Uw__"